module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_14 (21).c3e3d0e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_14 (21).mp4
// module id = 796
// module chunks = 1